/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Post, PublishPostRequest, PublishPostState } from "store/modules/posts/types";

const initialState: PublishPostState = {
    isRequesting: false,
    successPayload: null,
    errors: []
};

const publishPostSlice = createSlice({
    name: "posts@publishPost",
    initialState,
    reducers: {
        publishPostRequest: (
            state,
            action: PayloadAction<PublishPostRequest>
        ): void => {
            state.isRequesting = true;
            state.errors = [];
        },
        publishPostSuccess: (
            state,
            action: PayloadAction<Post | undefined>
        ): void => {
            state.isRequesting = false;
        },
        publishPostFailed: (
            state,
            action: PayloadAction<string[]>
        ): void => {
            state.isRequesting = false;
            state.errors = action.payload;
        }
    }
});

export const {
    publishPostFailed,
    publishPostRequest,
    publishPostSuccess
} = publishPostSlice.actions;
export default publishPostSlice.reducer;
